import { render } from "./ExpedientsList.vue?vue&type=template&id=75020275&scoped=true"
import script from "./ExpedientsList.vue?vue&type=script&lang=js"
export * from "./ExpedientsList.vue?vue&type=script&lang=js"

import "./ExpedientsList.vue?vue&type=style&index=0&id=75020275&lang=scss&scoped=true"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75020275"]])

export default __exports__